// extracted by mini-css-extract-plugin
export default {"menuWrapper":"TabsContainer_menuWrapper__YV2Bq"};